import request from '@/utils/request';

export function movieStatisticsApi() {
    return{
        // 小说统计列表
        moviesCollectRankingList: params => {
            return request({
                url: '/admin/index/statistics/movies_collect_list',
                method: 'get',
                params,
            });
        },

        moviesCollectRankingAll: params => {
            return request({
                url: '/admin/index/statistics/movies_rankings_all',
                method: 'get',
                params,
            });
        },
    }
}
